
   <nav class="navbar navbar-expand-lg navbar-light p-0">
      <div class="container nab_bar p-2 sticky">
        <a class="navbar-brand logo" routerLink="/home-page"><img src="/assets/website-assets/images/baba_balak_nath_logo.png" alt="baba_balak_nath_logo" class="img-fluid"></a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="true" aria-label="Toggle navigation">
         Menu <span class="navbar-toggler-icon"></span>
        </button>
        <!-- <div class="navbar-collapse collapse" id="navbarNav" [ngClass]="{'show': !hideDropdown}"  >
          <ul class="navbar-nav ml-auto">
            <li class="nav-item dropdown ">
                   <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">About US</a>
			     <div class="dropdown-menu custom-dropdown" aria-labelledby="navbarDropdown">
                <a class="dropdown-item" >History &amp; Mythology</a>
                <a class="dropdown-item" routerLink="/home-page/organization-chart" (click)="hideDropdown = true" >Organization Chart</a>
                <a class="dropdown-item" routerLink="/home-page/our-organization" (click)="hideDropdown = true" >Our Organisation</a>
                
              </div>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown1" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true"> Facilities Accommodation</a>
              <div class="dropdown-menu custom-dropdown1" aria-labelledby="navbarDropdown" style="" data-bs-popper="none">
                <a class="dropdown-item" routerLink="/home-page/free-accommodation">Free Accommodations</a>
                <a class="dropdown-item" routerLink="/home-page/rented-accommodation">Rented Accommodations</a>
                <a class="dropdown-item" routerLink="/home-page/free-langar">Free Langar</a>
                <a class="dropdown-item" routerLink="/home-page/blanket-store">Blanket Store</a>
                <a class="dropdown-item" >HPPWD Rest House</a>
                <a class="dropdown-item" routerLink="/home-page/medical-facilities">Medical Facilites</a>
                <a class="dropdown-item" >Water atms</a>
                <a class="dropdown-item" >Sidh Anchal Hotel</a>
              </div>
            </li>
            <li class="nav-item">
              <a class="nav-link" > Blogs</a>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown2" role=" button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="fals">Gallery</a>
             <div class="dropdown-menu custom-dropdown3" aria-labelledby="navbarDropdown">
                <a class="dropdown-item" >Photos</a>
                <a class="dropdown-item" >Videos</a>
                <a class="dropdown-item" >Publications</a>
              
              </div>
            </li>
              <li class="nav-item dropdown desk-help">
                <a class="nav-link dropdown-toggle " href="#" id="navbarDropdown3" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Help Desk</a>
                 <div class="dropdown-menu custom-dropdown2" aria-labelledby="navbarDropdown">
                     <a class="dropdown-item" routerLink="/home-page/road-map" >Road Map</a>
                     <a class="dropdown-item" >Shelter and Shed</a>
                     <a class="dropdown-item" >Lost &amp; Found Items</a>
                     <a class="dropdown-item" routerLink="/home-page/poojan-reservation">Poojan Reservation</a>
                     <a class="dropdown-item" >Enquiry &amp; Accommodation</a>
                     <a class="dropdown-item" routerLink="/home-page/donation-policy">Donation Policy</a>
                     <a class="dropdown-item" >FAQs</a>
                   </div>
             </li>
             <li class="nav-item">
              <a class="nav-link booking_service" routerLink="/online-services/login">Booking Online Service</a>
            </li>
            </ul>
        </div> -->

       
        
        
        <div class="navbar-collapse collapse" id="navbarNav" [ngClass]="{'show': !hideDropdown}">
          <ul class="navbar-nav ml-auto">
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" (click)="hideDropdown = !hideDropdown">About US</a>
              <div class="dropdown-menu custom-dropdown" aria-labelledby="navbarDropdown">
                <a class="dropdown-item" routerLink="/home-page/history&mythology" (click)="hideDropdown = true">History &amp; Mythology</a>
                <a class="dropdown-item" routerLink="/home-page/organization-chart" (click)="hideDropdown = true">Organization Chart</a>
                <a class="dropdown-item" routerLink="/home-page/our-organization" (click)="hideDropdown = true">Our Organisation</a>
              </div>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown1" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true" (click)="hideDropdown = !hideDropdown"> Facilities Accommodation</a>
              <div class="dropdown-menu custom-dropdown1" aria-labelledby="navbarDropdown" style="" data-bs-popper="none">
                <!-- <a class="dropdown-item" routerLink="/home-page/free-accommodation"(click)="hideDropdown = true">Free Accommodations</a> -->
                <a class="dropdown-item" routerLink="/home-page/rented-accommodation"(click)="hideDropdown = true">Rented Accommodations</a>
                <a class="dropdown-item" routerLink="/home-page/free-langar"(click)="hideDropdown = true">Free Langar</a>
                <a class="dropdown-item" routerLink="/home-page/blanket-store"(click)="hideDropdown = true">Blanket Store</a>
                <!-- <a class="dropdown-item" >HPPWD Rest House</a> -->
                <a class="dropdown-item" routerLink="/home-page/medical-facilities"(click)="hideDropdown = true">Medical Facilites</a>
                <a class="dropdown-item" routerLink="/home-page/water-atms">Water atms</a>
                <!-- <a class="dropdown-item" >Sidh Anchal Hotel</a> -->
              </div>
            </li>
            <li class="nav-item">
              <a class="nav-link" (click)="hideDropdown = !hideDropdown" > Blogs</a>
            </li>
            <li class="nav-item dropdown d-md-none d-lg-none" >
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown2" role=" button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="fals" (click)="hideDropdown = !hideDropdown">Tenders & Notifications</a>
             <div class="dropdown-menu custom-dropdown3" aria-labelledby="navbarDropdown">
                <a class="dropdown-item"routerLink="/home-page/tenders"  (click)="hideDropdown = true">Tenders</a>
                <a class="dropdown-item"routerLink="/home-page/notification" (click)="hideDropdown = true" >Notifications</a>
              
              </div>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown2" role=" button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="fals" (click)="hideDropdown = !hideDropdown">Gallery</a>
             <div class="dropdown-menu custom-dropdown3" aria-labelledby="navbarDropdown">
                <a class="dropdown-item" routerLink="/home-page/photos" (click)="hideDropdown = true">Photos</a>
                <a class="dropdown-item" routerLink="/home-page/videos"(click)="hideDropdown = true" >Videos</a>
                <a class="dropdown-item" >Publications</a>
              
              </div>
            </li>
            <li class="nav-item dropdown desk-help">
              <a class="nav-link dropdown-toggle " href="#" id="navbarDropdown3" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" (click)="hideDropdown = !hideDropdown">Help Desk</a>
               <div class="dropdown-menu custom-dropdown2" aria-labelledby="navbarDropdown">
                   <a class="dropdown-item" routerLink="/home-page/road-map" (click)="hideDropdown = true" >Road Map</a>
                   <a class="dropdown-item" routerLink="/home-page/shelter-and-shed"  (click)="hideDropdown = true">Shelter and Shed</a>
                   <a class="dropdown-item" routerLink="/home-page/lost-&-found-items"  (click)="hideDropdown = true">Lost &amp; Found Items</a>
                   <a class="dropdown-item" routerLink="/home-page/poojan-reservation" (click)="hideDropdown = true">Poojan Reservation</a>
                   <a class="dropdown-item" (click)="hideDropdown = true">Enquiry &amp; Accommodation</a>
                   <a class="dropdown-item" routerLink="/home-page/donation-policy" (click)="hideDropdown = true">Donation Policy</a>
                   <a class="dropdown-item" routerLink="/home-page/do-and-dont" (click)="hideDropdown = true" >Do's & Don'ts</a>
                 </div>
           </li>
           
           <li class="nav-item">
            <a class="nav-link booking_service" routerLink="/online-services/login">Booking Online Service</a>
          </li>
          </ul>
        </div>
        
        
        
        
      </div>
    </nav>

